import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { datadogLogger } from '../datadog/logger';

type Props = {
    to: string;
};

export const NotFoundRedirect = ({ to }: Props): JSX.Element => {
    const { pathname, search, hash } = useLocation();

    useEffect(() => {
        datadogLogger.warn('Route not found, redirecting', {
            attemptedPath: pathname,
            attemptedSearch: search,
            attemptedHash: hash,
            redirectTo: to,
            referrer: document.referrer || null,
        });
    }, [pathname, search, hash, to]);

    return <Navigate to={to} replace />;
};
